import { Box, Typography } from "@material-ui/core";
import React, { FC } from "react";

export const CalculatorHeader: FC = ({ children }) => {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignContent="center">
      {children}
    </Box>
  );
};
